import noUiSlider from 'nouislider';
! function(e) {
    "use strict";
    e.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": e('meta[name="csrf-token"]').attr("content")
        }
    }), window.botbleCookieNewsletter = function() {
        var t = "botble_cookie_newsletter",
            a = e("div[data-session-domain]").data("session-domain"),
            o = e("#subscribe"),
            s = o.data("time");

        function r(e) {
            ! function(e, t, o) {
                var s = new Date;
                s.setTime(s.getTime() + 24 * o * 60 * 60 * 1e3), document.cookie = e + "=" + t + ";expires=" + s.toUTCString() + ";domain=" + a + ";path=/"
            }(t, 1, e)
        }

        function n(e) {
            return -1 !== document.cookie.split("; ").indexOf(e + "=1")
        }
        return n(t) || setTimeout((function() {
            o.length > 0 && (o.addClass("active"), e("body").css("overflow", "hidden"))
        }), s), {
            newsletterWithCookies: r,
            hideCookieDialog: function() {
                !n(t) && e("#dont_show_again").is(":checked") ? r(3) : r(1 / 24)
            }
        }
    }();
    var t = function(e) {
            window.showAlert("alert-danger", e)
        },
        a = function(e) {
            window.showAlert("alert-success", e)
        },
        o = function(a) {
            void 0 !== a.errors && a.errors.length ? s(a.errors) : void 0 !== a.responseJSON ? void 0 !== a.responseJSON.errors ? 422 === a.status && s(a.responseJSON.errors) : void 0 !== a.responseJSON.message ? t(a.responseJSON.message) : e.each(a.responseJSON, (function(a, o) {
                e.each(o, (function(e, a) {
                    t(a)
                }))
            })) : t(a.statusText)
        },
        s = function(a) {
            var o = "";
            e.each(a, (function(e, t) {
                "" !== o && (o += "<br />"), o += t
            })), t(o)
        };
    window.showAlert = function(t, a) {
        if (t && "" !== a) {
            var o = Math.floor(1e3 * Math.random()),
                s = '<div class="alert '.concat(t, ' alert-dismissible" id="').concat(o, '">\n                            <span class="close icon-cross2" data-dismiss="alert" aria-label="close"></span>\n                            <i class="icon-') + ("alert-success" === t ? "checkmark-circle" : "cross-circle") + ' message-icon"></i>\n                            '.concat(a, "\n                        </div>");
            e("#alert-container").append(s).ready((function() {
                window.setTimeout((function() {
                    e("#alert-container #".concat(o)).remove()
                }), 6e3)
            }))
        }
    }, e(document).ready((function() {
        window.onBeforeChangeSwatches = function() {
            e(".add-to-cart-form button[type=submit]").prop("disabled", !0).addClass("btn-disabled")
        }, window.onChangeSwatchesSuccess = function(t) {
            if (e(".add-to-cart-form .error-message").hide(), e(".add-to-cart-form .success-message").hide(), t.error) e(".add-to-cart-form button[type=submit]").prop("disabled", !0).addClass("btn-disabled"), e(".number-items-available").html('<span class="text-danger">(' + t.message + ")</span>").show(), e(".hidden-product-id").val("");
            else {
                e(".add-to-cart-form").find(".error-message").hide(), e(".ps-product__price span").text(t.data.display_sale_price), t.data.sale_price !== t.data.price ? e(".ps-product__price del").text(t.data.display_price).show() : e(".ps-product__price del").hide(), e(".ps-product__specification #product-sku").text(t.data.sku), e(".hidden-product-id").val(t.data.id), e(".add-to-cart-form button[type=submit]").prop("disabled", !1).removeClass("btn-disabled"), e(".number-items-available").html('<span class="text-success">(' + t.message + ")</span>").show();
                var a = e(document).find(".ps-product--quickview .ps-product__images");
                if (a.length) {
                    a.slick("unslick");
                    var o = "";
                    t.data.image_with_sizes.origin.forEach((function(e) {
                        o += '<div class="item"><img src="' + e + '" alt="image"/></div>'
                    })), a.html(o), a.slick({
                        slidesToShow: a.data("item"),
                        slidesToScroll: 1,
                        infinite: !1,
                        arrows: a.data("arrow"),
                        focusOnSelect: !0,
                        prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
                        nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>"
                    })
                }
                var s = e(".ps-product--detail");
                if (s.length > 0) {
                    var r = s.find(".ps-product__gallery"),
                        n = s.find(".ps-product__variants"),
                        i = s.find(".ps-product__thumbnail").data("vertical");
                    if (r.length) {
                        r.slick("unslick");
                        var l = "";
                        t.data.image_with_sizes.origin.forEach((function(e) {
                            l += '<div class="item"><a href="' + e + '"><img src="' + e + '" alt="image"/></a></div>'
                        })), r.html(l), r.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            asNavFor: ".ps-product__variants",
                            fade: !0,
                            dots: !1,
                            infinite: !1,
                            arrows: r.data("arrow"),
                            prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
                            nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>"
                        })
                    }
                    if (n.length) {
                        n.slick("unslick");
                        var c = "";
                        t.data.image_with_sizes.thumb.forEach((function(e) {
                            c += '<div class="item"><img src="' + e + '" alt="image"/></div>'
                        })), n.html(c), n.slick({
                            slidesToShow: n.data("item"),
                            slidesToScroll: 1,
                            infinite: !1,
                            arrows: n.data("arrow"),
                            focusOnSelect: !0,
                            prevArrow: "<a href='#'><i class='fa fa-angle-up'></i></a>",
                            nextArrow: "<a href='#'><i class='fa fa-angle-down'></i></a>",
                            asNavFor: ".ps-product__gallery",
                            vertical: i,
                            responsive: [{
                                breakpoint: 1200,
                                settings: {
                                    arrows: n.data("arrow"),
                                    slidesToShow: 4,
                                    vertical: !1,
                                    prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
                                    nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>"
                                }
                            }, {
                                breakpoint: 992,
                                settings: {
                                    arrows: n.data("arrow"),
                                    slidesToShow: 4,
                                    vertical: !1,
                                    prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
                                    nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>"
                                }
                            }, {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 3,
                                    vertical: !1,
                                    prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
                                    nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>"
                                }
                            }]
                        })
                    }
                }
                e(window).trigger("resize"), s.length > 0 && (s.find(".ps-product__gallery").data("lightGallery").destroy(!0), s.find(".ps-product__gallery").lightGallery({
                    selector: ".item a",
                    thumbnail: !0,
                    share: !1,
                    fullScreen: !1,
                    autoplay: !1,
                    autoplayControls: !1,
                    actualSize: !1
                }))
            }
        }, e(".ps-panel--sidebar").show(), e(".ps-popup").show(), e(".menu--product-categories .menu__content").show(), e(".ps-popup__close").on("click", (function(t) {
            t.preventDefault(), e(this).closest(".ps-popup").removeClass("active"), e("body").css("overflow", "auto"), window.botbleCookieNewsletter.hideCookieDialog()
        })), e("#subscribe").on("click", (function(t) {
            e(t.target).closest(".ps-popup__content").length || (e(this).removeClass("active"), e("body").css("overflow-y", "auto"), window.botbleCookieNewsletter.hideCookieDialog())
        })), e(document).on("click", ".newsletter-form button[type=submit]", (function(s) {
            s.preventDefault(), s.stopPropagation();
            var r = e(this);
            r.addClass("button-loading"), e.ajax({
                type: "POST",
                cache: !1,
                url: r.closest("form").prop("action"),
                data: new FormData(r.closest("form")[0]),
                contentType: !1,
                processData: !1,
                success: function(e) {
                    r.removeClass("button-loading"), "undefined" != typeof refreshRecaptcha && refreshRecaptcha(), e.error ? t(e.message) : (window.botbleCookieNewsletter.newsletterWithCookies(30), r.closest("form").find("input[type=email]").val(""), a(e.message), setTimeout((function() {
                        r.closest(".modal-body").find('button[data-dismiss="modal"]').trigger("click")
                    }), 2e3))
                },
                error: function(e) {
                    "undefined" != typeof refreshRecaptcha && refreshRecaptcha(), r.removeClass("button-loading"), o(e)
                }
            })
        })), e(document).on("click", ".ps-form--download-app button[type=submit]", (function(t) {
            t.preventDefault();
            var a = e(t.currentTarget);
            a.addClass("button-loading"), e.ajax({
                url: a.closest("form").prop("action"),
                data: a.closest("form").serialize(),
                type: "POST",
                success: function(e) {
                    if (e.error) return a.removeClass("button-loading"), window.showAlert("alert-danger", e.message), !1;
                    window.showAlert("alert-success", e.message), a.removeClass("button-loading")
                },
                error: function(e) {
                    a.removeClass("button-loading"), o(e, a.closest("form"))
                }
            })
        }));
        var s = e(".ps-layout--shop");
        s.length > 0 && (e(document).on("click", "#products-filter-sidebar", (function(e) {
            e.preventDefault(), s.find(".ps-layout__left").toggleClass("active")
        })), e(".ps-layout__left .ps-filter__header .ps-btn--close").on("click", (function(e) {
            e.preventDefault(), s.find(".ps-layout__left").toggleClass("active")
        })), e(document).on("click", ".ps-layout__left .screen-darken", (function(e) {
            e.preventDefault(), s.find(".ps-layout__left").toggleClass("active")
        })), e(".ps-select-shop-sort").on("change", (function(t) {
            r.find("input[name=sort-by]").val(e(t.currentTarget).val()), r.trigger("submit")
        })));
        var r = e("#products-filter-form"),
            n = ".ps-products-listing",
            i = e(n),
            l = !0;

        function c(t) {
            t.closest(".ps-table--shopping-cart").addClass("content-loading"), e.ajax({
                type: "POST",
                cache: !1,
                url: t.closest("form").prop("action"),
                data: new FormData(t.closest("form")[0]),
                contentType: !1,
                processData: !1,
                success: function(a) {
                    if (a.error) return window.showAlert("alert-danger", a.message), t.closest(".ps-table--shopping-cart").removeClass("content-loading"), !1;
                    e(".ps-section--shopping").load(window.location.href + " .ps-section--shopping > *"), e.ajax({
                        url: window.siteUrl + "/ajax/cart",
                        method: "GET",
                        success: function(o) {
                            o.error || (t.closest(".ps-table--shopping-cart").removeClass("content-loading"), e(".ps-cart--mobile").html(o.data.html), e(".btn-shopping-cart span i").text(o.data.count), window.showAlert("alert-success", a.message))
                        },
                        error: function(e) {
                            t.closest(".ps-table--shopping-cart").removeClass("content-loading"), window.showAlert("alert-danger", e.message)
                        }
                    })
                },
                error: function(e) {
                    t.closest(".ps-table--shopping-cart").removeClass("content-loading"), window.showAlert("alert-danger", e.message)
                }
            })
        }
        e(document).on("change", ".product-filter-item", (function() {
            l && e(this).closest("form").trigger("submit")
        })), e(document).on("click", ".ps-shopping .prodducts-layout li:not(.active) a", (function(t) {
            t.preventDefault();
            var a = e(t.currentTarget);
            a.closest("ul").find("li").removeClass("active"), a.closest("li").addClass("active"), r.find("input[name=layout]").val(a.data("layout")).trigger("change")
        })), r.length && (e(document).on("submit", "#products-filter-form", (function(a) {
            a.preventDefault();
            var s = e(a.currentTarget),
                n = function(e) {
                    var t = [];
                    return e.forEach((function(e) {
                        if (e.value) {
                            if (["min_price", "max_price"].includes(e.name) && r.find("input[name=" + e.name + "]").data(e.name.substring(0, 3)) == parseInt(e.value)) return;
                            t.push(e)
                        }
                    })), t
                }(s.serializeArray()),
                l = [],
                c = i.find("input[name=page]");
            c.val() && n.push({
                name: "page",
                value: c.val()
            }), n.map((function(e) {
                l.push(encodeURIComponent(e.name) + "=" + e.value)
            }));
            var d = s.attr("action") + (l && l.length ? "?" + l.join("&") : "");
            n.push({
                name: "_",
                value: +new Date
            }), e.ajax({
                url: s.attr("action"),
                type: "GET",
                data: n,
                beforeSend: function() {
                    i.find(".loading").show(), e("html, body").animate({
                        scrollTop: e(".ps-shopping").offset().top - 200
                    }, 500);
                    var t = r.find(".nonlinear");
                    t.length && t[0].noUiSlider.set([r.find("input[name=min_price]").val(), r.find("input[name=max_price]").val()]), e(".ps-layout__left").removeClass("active")
                },
                success: function(a) {
                    if (0 == a.error) {
                        i.html(a.data);
                        var o = a.message;
                        o && e(".ps-shopping .products-found").html("<strong>" + o.substr(0, o.indexOf(" ")) + '</strong><span class="ms-1">' + o.substr(o.indexOf(" ") + 1) + "</span>"), d != window.location.href && window.history.pushState(n, a.message, d)
                    } else t(a.message || "Opp!")
                },
                error: function(e) {
                    o(e)
                },
                complete: function() {
                    i.find(".loading").hide()
                }
            })
        })), window.addEventListener("popstate", (function(t) {
            var a = window.location.origin + window.location.pathname;
            r.length ? (r.attr("action", a), function(t) {
                l = !1, r.find("input, select, textarea").each((function(a, o) {
                    var s = e(o),
                        r = s.attr("name"),
                        n = t[r] || null;
                    switch (s.attr("type")) {
                        case "checkbox":
                            s.prop("checked", !1), Array.isArray(n) ? s.prop("checked", n.includes(s.val())) : s.prop("checked", !!n);
                            break;
                        default:
                            s.is("[name=max_price]") ? s.val(n || s.data("max")) : s.is("[name=min_price]") ? s.val(n || s.data("min")) : s.val() != n && s.val(n)
                    }
                })), l = !0
            }(function(e) {
                for (var t, a = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], o = e || window.location.search.substring(1), s = /([^&=]+)=?([^&]*)/g, r = /\+/g, n = function(e) {
                        return decodeURIComponent(e.replace(r, " "))
                    }, i = {}; t = s.exec(o);) {
                    var l = n(t[1]),
                        c = n(t[2]);
                    "[]" == l.substring(l.length - 2) ? (a && (l = l.substring(0, l.length - 2)), (i[l] || (i[l] = [])).push(c)) : i[l] = c
                }
                return i
            }()), r.trigger("submit")) : history.back()
        }), !1), e(document).on("click", n + " .pagination a", (function(t) {
            t.preventDefault();
            var a = new URL(e(t.currentTarget).attr("href")).searchParams.get("page");
            i.find("input[name=page]").val(a), r.trigger("submit")
        }))), e(document).on("click", ".ps-list--categories li a", (function(t) {
            t.preventDefault();
            var a = e(t.currentTarget),
                o = a.attr("href"),
                s = a.parent();
            s.hasClass("current-menu-item") ? (s.removeClass("current-menu-item"), o = r.data("action")) : (a.closest(".ps-list--categories").find("li").removeClass("current-menu-item"), s.addClass("current-menu-item")), r.attr("action", o).trigger("submit")
        })), e(document).on("click", ".js-add-to-wishlist-button", (function(t) {
            t.preventDefault();
            var a = e(this);
            a.addClass("button-loading"), e.ajax({
                url: a.prop("href"),
                method: "POST",
                success: function(t) {
                    if (t.error) return a.removeClass("button-loading"), window.showAlert("alert-danger", t.message), !1;
                    window.showAlert("alert-success", t.message), e(".btn-wishlist span i").text(t.data.count), a.removeClass("button-loading").removeClass("js-add-to-wishlist-button").addClass("js-remove-from-wishlist-button active")
                },
                error: function(e) {
                    a.removeClass("button-loading"), window.showAlert("alert-danger", e.message)
                }
            })
        })), e(document).on("click", ".js-remove-from-wishlist-button", (function(t) {
            t.preventDefault();
            var a = e(this);
            a.addClass("button-loading"), e.ajax({
                url: a.prop("href"),
                method: "DELETE",
                success: function(t) {
                    if (t.error) return a.removeClass("button-loading"), window.showAlert("alert-danger", t.message), !1;
                    window.showAlert("alert-success", t.message), e(".btn-wishlist span i").text(t.data.count), a.closest("tr").remove(), a.removeClass("button-loading").removeClass("js-remove-from-wishlist-button active").addClass("js-add-to-wishlist-button")
                },
                error: function(e) {
                    a.removeClass("button-loading"), window.showAlert("alert-danger", e.message)
                }
            })
        })), e(document).on("click", ".js-add-to-compare-button", (function(t) {
            t.preventDefault();
            var a = e(this);
            a.addClass("button-loading"), e.ajax({
                url: a.prop("href"),
                method: "POST",
                success: function(t) {
                    if (t.error) return a.removeClass("button-loading"), window.showAlert("alert-danger", t.message), !1;
                    window.showAlert("alert-success", t.message), e(".btn-compare span i").text(t.data.count), a.removeClass("button-loading").removeClass("js-add-to-compare-button").addClass("js-remove-from-compare-button active")
                },
                error: function(e) {
                    a.removeClass("button-loading"), window.showAlert("alert-danger", e.message)
                }
            })
        })), e(document).on("click", ".js-remove-from-compare-button", (function(t) {
            t.preventDefault();
            var a = e(this),
                o = a.text();
            a.text(o + "..."), e.ajax({
                url: a.prop("href"),
                method: "DELETE",
                success: function(t) {
                    if (t.error) return a.text(o), window.showAlert("alert-danger", t.message), !1;
                    e(".ps-table--compare").load(window.location.href + " .ps-table--compare > *", (function() {
                        window.showAlert("alert-success", t.message), e(".btn-compare span i").text(t.data.count), a.text(o)
                    }))
                },
                error: function(e) {
                    a.removeClass("button-loading"), window.showAlert("alert-danger", e.message)
                }
            })
        })), e(document).on("click", ".add-to-cart-button", (function(t) {
            t.preventDefault();
            var a = e(this);
            a.prop("disabled", !0).addClass("button-loading"), e.ajax({
                url: a.prop("href"),
                method: "POST",
                data: {
                    id: a.data("id")
                },
                dataType: "json",
                success: function(t) {
                    if (a.prop("disabled", !1).removeClass("button-loading").addClass("active"), t.error) return window.showAlert("alert-danger", t.message), !1;
                    window.showAlert("alert-success", t.message), "checkout" === a.prop("name") && void 0 !== t.data.next_url ? window.location.href = t.data.next_url : e.ajax({
                        url: window.siteUrl + "/ajax/cart",
                        method: "GET",
                        success: function(t) {
                            t.error || (e(".ps-cart--mobile").html(t.data.html), e(".btn-shopping-cart span i").text(t.data.count))
                        }
                    })
                },
                error: function(e) {
                    a.prop("disabled", !1).removeClass("button-loading"), window.showAlert("alert-danger", e.message)
                }
            })
        })), e(document).on("click", ".remove-cart-item", (function(t) {
            t.preventDefault();
            var a = e(this);
            a.closest(".ps-product--cart-mobile").addClass("content-loading"), e.ajax({
                url: a.prop("href"),
                method: "GET",
                success: function(t) {
                    if (a.closest(".ps-product--cart-mobile").removeClass("content-loading"), t.error) return window.showAlert("alert-danger", t.message), !1;
                    e.ajax({
                        url: window.siteUrl + "/ajax/cart",
                        method: "GET",
                        success: function(a) {
                            a.error || (e(".ps-cart--mobile").html(a.data.html), e(".btn-shopping-cart span i").text(a.data.count), window.showAlert("alert-success", t.message))
                        }
                    })
                },
                error: function(e) {
                    a.closest(".ps-product--cart-mobile").removeClass("content-loading"), window.showAlert("alert-danger", e.message)
                }
            })
        })), e(document).on("click", ".add-to-cart-form button[type=submit]", (function(t) {
            t.preventDefault(), t.stopPropagation();
            var a = e(this);
            e(".hidden-product-id").val() ? (a.prop("disabled", !0).addClass("btn-disabled").addClass("button-loading"), a.closest("form").find(".error-message").hide(), a.closest("form").find(".success-message").hide(), e.ajax({
                type: "POST",
                cache: !1,
                url: a.closest("form").prop("action"),
                data: new FormData(a.closest("form")[0]),
                contentType: !1,
                processData: !1,
                success: function(t) {
                    if (a.prop("disabled", !1).removeClass("btn-disabled").removeClass("button-loading"), t.error) return a.removeClass("button-loading"), window.showAlert("alert-danger", t.message), !1;
                    window.showAlert("alert-success", t.message), "checkout" === a.prop("name") && void 0 !== t.data.next_url ? window.location.href = t.data.next_url : e.ajax({
                        url: window.siteUrl + "/ajax/cart",
                        method: "GET",
                        success: function(t) {
                            t.error || (e(".ps-cart--mobile").html(t.data.html), e(".btn-shopping-cart span i").text(t.data.count))
                        }
                    })
                },
                error: function(e) {
                    a.prop("disabled", !1).removeClass("btn-disabled").removeClass("button-loading"), o(e, a.closest("form"))
                }
            })) : a.prop("disabled", !0).addClass("btn-disabled")
        })), e(document).on("change", ".submit-form-on-change", (function() {
            e(this).closest("form").submit()
        })), e(document).on("click", ".form-review-product button[type=submit]", (function(s) {
            var r = this;
            s.preventDefault(), s.stopPropagation(), e(this).prop("disabled", !0).addClass("btn-disabled").addClass("button-loading"), e.ajax({
                type: "POST",
                cache: !1,
                url: e(this).closest("form").prop("action"),
                data: new FormData(e(this).closest("form")[0]),
                contentType: !1,
                processData: !1,
                success: function(o) {
                    o.error ? t(o.message) : (e(r).closest("form").find("select").val(0), e(r).closest("form").find("textarea").val(""), a(o.message), setTimeout((function() {
                        window.location.reload()
                    }), 1500)), e(r).prop("disabled", !1).removeClass("btn-disabled").removeClass("button-loading")
                },
                error: function(t) {
                    e(r).prop("disabled", !1).removeClass("btn-disabled").removeClass("button-loading"), o(t, e(r).closest("form"))
                }
            })
        })), e(".form-coupon-wrapper .coupon-code").keypress((function(t) {
            if (13 === t.keyCode) return e(".apply-coupon-code").trigger("click"), t.preventDefault(), t.stopPropagation(), !1
        })), e(document).on("click", ".btn-apply-coupon-code", (function(t) {
            t.preventDefault();
            var a = e(t.currentTarget);
            a.prop("disabled", !0).addClass("btn-disabled").addClass("button-loading"), e.ajax({
                url: a.data("url"),
                type: "POST",
                data: {
                    coupon_code: a.closest(".form-coupon-wrapper").find(".coupon-code").val()
                },
                headers: {
                    "X-CSRF-TOKEN": e('meta[name="csrf-token"]').attr("content")
                },
                success: function(t) {
                    t.error ? (window.showAlert("alert-danger", t.message), a.prop("disabled", !1).removeClass("btn-disabled").removeClass("button-loading")) : e(".ps-section--shopping").load(window.location.href + "?applied_coupon=1 .ps-section--shopping > *", (function() {
                        a.prop("disabled", !1).removeClass("btn-disabled").removeClass("button-loading"), window.showAlert("alert-success", t.message)
                    }))
                },
                error: function(t) {
                    void 0 !== t.responseJSON ? "undefined" !== t.responseJSON.errors ? e.each(t.responseJSON.errors, (function(t, a) {
                        e.each(a, (function(e, t) {
                            window.showAlert("alert-danger", t)
                        }))
                    })) : void 0 !== t.responseJSON.message && window.showAlert("alert-danger", t.responseJSON.message) : window.showAlert("alert-danger", t.status.text), a.prop("disabled", !1).removeClass("btn-disabled").removeClass("button-loading")
                }
            })
        })), e(document).on("click", ".btn-remove-coupon-code", (function(t) {
            t.preventDefault();
            var a = e(t.currentTarget),
                o = a.text();
            a.text(a.data("processing-text")), e.ajax({
                url: a.data("url"),
                type: "POST",
                headers: {
                    "X-CSRF-TOKEN": e('meta[name="csrf-token"]').attr("content")
                },
                success: function(t) {
                    t.error ? (window.showAlert("alert-danger", t.message), a.text(o)) : e(".ps-section--shopping").load(window.location.href + " .ps-section--shopping > *", (function() {
                        a.text(o)
                    }))
                },
                error: function(t) {
                    void 0 !== t.responseJSON ? "undefined" !== t.responseJSON.errors ? e.each(t.responseJSON.errors, (function(t, a) {
                        e.each(a, (function(e, t) {
                            window.showAlert("alert-danger", t)
                        }))
                    })) : void 0 !== t.responseJSON.message && window.showAlert("alert-danger", t.responseJSON.message) : window.showAlert("alert-danger", t.status.text), a.text(o)
                }
            })
        })), e(".nonlinear").each((function(t, a) {
            var o = e(a),
                s = o.data("min"),
                r = o.data("max"),
                n = e(a).closest(".nonlinear-wrapper");
            noUiSlider.create(a, {
                connect: !0,
                behaviour: "tap",
                start: [n.find(".product-filter-item-price-0").val(), n.find(".product-filter-item-price-1").val()],
                range: {
                    min: s,
                    "10%": .1 * r,
                    "20%": .2 * r,
                    "30%": .3 * r,
                    "40%": .4 * r,
                    "50%": .5 * r,
                    "60%": .6 * r,
                    "70%": .7 * r,
                    "80%": .8 * r,
                    "90%": .9 * r,
                    max: r
                }
            });
            var i = [e(".ps-slider__min"), e(".ps-slider__max")],
                l = parseFloat(e("div[data-current-exchange-rate]").data("current-exchange-rate"));
            a.noUiSlider.on("update", (function(e, t) {
                var a, o, s, r, n, c, d, u, p;
                i[t].html((a = Math.round(e[t] * l), n = isFinite(+a) ? +a : 0, c = isFinite(+o) ? Math.abs(o) : 0, d = void 0 === r ? "," : r, u = void 0 === s ? "." : s, (p = (c ? function(e, t) {
                    var a = Math.pow(10, t);
                    return Math.round(e * a) / a
                }(n, c) : Math.round(n)).toString().split("."))[0].length > 3 && (p[0] = p[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, d)), (p[1] || "").length < c && (p[1] = p[1] || "", p[1] += new Array(c - p[1].length + 1).join("0")), p.join(u)))
            })), a.noUiSlider.on("change", (function(e, t) {
                n.find(".product-filter-item-price-" + t).val(Math.round(e[t] * l)).trigger("change")
            }))
        })), e(document).on("change", ".product-category-select", (function() {
            e(".product-cat-label").text(e.trim(e(this).find("option:selected").text()))
        })), e(".product-cat-label").text(e.trim(e(".product-category-select option:selected").text()));
        var d = null;
        e("#input-search").on("keydown", (function() {
            e(".ps-panel--search-result").html("").removeClass("active")
        })).on("keyup", (function() {
            e(this).val() && (e(".ps-form--quick-search .spinner-icon").show(), clearTimeout(d), d = setTimeout((function() {
                var t = e(".ps-form--quick-search");
                e.ajax({
                    type: "GET",
                    url: t.data("ajax-url"),
                    data: t.serialize(),
                    success: function(t) {
                        t.error || "" === t.data ? e(".ps-panel--search-result").html("").removeClass("active") : e(".ps-panel--search-result").html(t.data).addClass("active"), e(".ps-form--quick-search .spinner-icon").hide()
                    },
                    error: function() {
                        e(".ps-form--quick-search .spinner-icon").hide()
                    }
                })
            }), 500))
        })), e(".rating_wrap > a ").on("click", (function(t) {
            t.preventDefault();
            var a = e(this).attr("href");
            e(".ps-tab-list li").removeClass("active"), e('.ps-tab-list li > a[href="' + a + '"]').closest("li").addClass("active"), e(a).addClass("active"), e(a).siblings(".ps-tab").removeClass("active"), e(a).closest(".ps-tab-root").find("li").removeClass("active"), e(a).closest(".ps-tab-root").find('li a[href="' + a + '"]').closest("li").addClass("active"), e("html, body").animate({
                scrollTop: e(a).offset().top - e(".header--product .navigation").height() - 165 + "px"
            }, 800)
        })), e(document).on("click", "input[name=is_vendor]", (function() {
            1 == e(this).val() ? e(".show-if-vendor").slideDown().show() : (e(".show-if-vendor").slideUp(), setTimeout((function() {
                e(".show-if-vendor").hide()
            }), 500))
        })), e("#shop-url").on("keyup", (function() {
            var t = e(this).closest(".form-group").find("span small");
            t.html(t.data("base-url") + "/<strong>" + e(this).val().toLowerCase() + "</strong>")
        })).on("change", (function() {
            var t = this;
            e(".shop-url-wrapper").addClass("content-loading"), e(this).closest("form").find("button[type=submit]").addClass("btn-disabled").prop("disabled", !0), e.ajax({
                url: e(this).data("url"),
                type: "POST",
                data: {
                    url: e(this).val()
                },
                success: function(a) {
                    e(".shop-url-wrapper").removeClass("content-loading"), a.error ? e(".shop-url-status").removeClass("text-success").addClass("text-danger").text(a.message) : (e(".shop-url-status").removeClass("text-danger").addClass("text-success").text(a.message), e(t).closest("form").find("button[type=submit]").prop("disabled", !1).removeClass("btn-disabled"))
                },
                error: function() {
                    e(".shop-url-wrapper").removeClass("content-loading")
                }
            })
        }))
    }))
}(jQuery);
